global.coreui = require("@coreui/coreui-pro")
import { Application } from "@hotwired/stimulus"
import { definitionsFromContext } from "@hotwired/stimulus-webpack-helpers"

window.Stimulus = Application.start()
const context = require.context("../controllers", true, /\.js$/)
Stimulus.load(definitionsFromContext(context))

const tooltipTriggerList = document.querySelectorAll('[data-coreui-toggle="tooltip"]')
const tooltipList = [...tooltipTriggerList].map(tooltipTriggerEl => new coreui.Tooltip(tooltipTriggerEl))

const carouselElementList = document.querySelectorAll('.carousel')
const carouselList = [...carouselElementList].map(carouselEl => new coreui.Carousel(carouselEl, {
  interval: false // Disable automatic cycling
}))
